export { OrganizationPage as default } from '@/components/enpages/Ir/Governance/Organization'
